import script from "./HeaderDesignmuseumgent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDesignmuseumgent.vue?vue&type=script&setup=true&lang=js"

import "./HeaderDesignmuseumgent.vue?vue&type=style&index=0&id=1f3fe99b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f3fe99b"]])

export default __exports__